import { testimonyRepository } from "../../../providers/repositories/testimonyRepository";
import { Testimony } from "../entities/Testimony";
import { toast } from "react-toastify";
import { t } from "i18next";
import Logger from "../../../utils/Logger";

export const updateTestimonyOrderUseCase = {
    async exec(list: Testimony[]): Promise<boolean> {
        try {
            await testimonyRepository.updateOrder(list);
            toast.success(t("action.updateSuccess"));
            return true;
        } catch (error) {
            Logger.error("updateTestimonyOrderUseCase", error);
            toast.error(t("action.updateError"));
        }
        return false;
    },
};
